import React from 'react';

export default function PlayerSecondaryNav({
  user,
  view,
  setView,
  activePlayerId,
  activeSeasonId,
  players
}) {
  const navItems = [
    { id: 'dashboard', label: 'Players', icon: '👤' },
    { id: 'player-dashboard', label: 'Seasons', icon: '🏆' },
    { id: 'season-detail', label: 'Stats', icon: '📊' },
    { id: 'record', label: 'Record', icon: '📝' },
    { id: 'trends', label: 'Trends', icon: '📉' }
  ];

  // Only show if we're in a player view (not auth, account, pricing, team views)
  const playerViews = ['dashboard', 'player-dashboard', 'season-detail', 'record', 'trends', 'match-history', 'player-setup', 'season-setup', 'season-edit', 'tournament-detail', 'tournament-create', 'tournament-edit'];

  if (!playerViews.includes(view)) {
    return null;
  }

  // Filter nav items based on context
  let visibleNavItems = [...navItems];

  // If no player selected, only show "Players"
  if (!activePlayerId) {
    visibleNavItems = navItems.filter(item => item.id === 'dashboard');
  }
  // If player selected but no season, show Players and Seasons
  else if (!activeSeasonId) {
    visibleNavItems = navItems.filter(item => ['dashboard', 'player-dashboard'].includes(item.id));
  }
  // If both selected, show all items

  return (
    <div className="player-secondary-nav" style={{
      background: 'rgba(255, 255, 255, 0.8)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      position: 'sticky',
      top: '0',
      zIndex: 800
    }}>
      <div className="wrap" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '12px 20px'
      }}>
        {/* Player Selector Row */}
        {activePlayerId && players && players.length > 0 && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginTop: '8px',
            marginBottom: '16px',
            paddingBottom: '16px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
            flexWrap: 'wrap'
          }}>
            <span style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#8E8E93',
              whiteSpace: 'nowrap',
              textTransform: 'uppercase',
              letterSpacing: '0.02em'
            }}>
              Player:
            </span>
            {players.length === 1 ? (
              <span style={{
                fontSize: '15px',
                fontWeight: '600',
                color: '#000000',
                letterSpacing: '-0.02em'
              }}>
                {players[0].name}
              </span>
            ) : (
              <select
                value={activePlayerId || ''}
                onChange={(e) => {
                  const event = new CustomEvent('playerChange', { detail: e.target.value });
                  window.dispatchEvent(event);
                }}
                style={{
                  padding: '8px 14px',
                  paddingRight: '38px',
                  border: '1px solid #D1D1D6',
                  borderRadius: '10px',
                  fontSize: '15px',
                  background: 'white',
                  cursor: 'pointer',
                  fontWeight: '400',
                  color: '#000000',
                  appearance: 'none',
                  backgroundImage: 'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'%3E%3Cpath fill=\'none\' stroke=\'%23007AFF\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M2 5l6 6 6-6\'/%3E%3C/svg%3E")',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 12px center',
                  backgroundSize: '16px',
                  minWidth: '160px',
                  minHeight: '36px'
                }}
              >
                {players.map(player => (
                  <option key={player.id} value={player.id}>
                    {player.name}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}

        {/* Navigation Pills */}
        <div style={{
          display: 'flex',
          gap: '4px',
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          paddingBottom: '2px'
        }}>
          <style>
            {`
              div::-webkit-scrollbar {
                display: none;
              }
            `}
          </style>
          {visibleNavItems.map(item => {
            const isActive = view === item.id;

            return (
              <button
                key={item.id}
                onClick={() => setView(item.id)}
                style={{
                  padding: '7px 12px',
                  background: isActive ? '#E5E5EA' : 'transparent',
                  border: 'none',
                  borderRadius: '10px',
                  color: isActive ? '#000000' : '#8E8E93',
                  fontSize: '13px',
                  fontWeight: isActive ? '600' : '400',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  flexShrink: 0,
                  minHeight: '34px'
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = '#F2F2F7';
                    e.currentTarget.style.color = '#000000';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#8E8E93';
                  }
                }}
              >
                <span style={{ fontSize: '15px', lineHeight: '1' }}>{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Add media query to hide labels on small screens */}
      <style>
        {`
          @media (max-width: 640px) {
            .nav-label {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
}
